import { Button, Spinner } from '@kcftech/design-system';
import { useMemo } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

// `!important` necessary because of dsm <-> styled-components weirdness
const TriggerPasswordResetButtonSpinner = styled(Spinner)`
    color: ${tokens.text.onColor} !important;
`;

export type TriggerPasswordResetButtonProps = Readonly<{
    processing: boolean;
    disabled: boolean;
    onResetClick: () => void;
}>;

export function TriggerPasswordResetButton({
    processing,
    disabled,
    onResetClick,
}: TriggerPasswordResetButtonProps) {
    const buttonTitle = useMemo(() => {
        if (processing) {
            return 'Processing password reset request';
        }
        if (disabled) {
            return 'Password reset unavailable for SSO and disabled users';
        }
        return 'Initiate password reset flow';
    }, [processing, disabled]);

    return (
        <Button
            className="mb-20"
            title={buttonTitle}
            appearance="danger"
            disabled={disabled || processing}
            onClick={onResetClick}
            icon={
                processing ? (
                    <TriggerPasswordResetButtonSpinner
                        className="inline-block"
                        size="1x"
                    />
                ) : undefined
            }
        >
            Initiate Password Reset
        </Button>
    );
}
